module.exports = __webpack_public_path__ + "img/pen-safe.e1f9df77.svg";